import { render, staticRenderFns } from "./registers-with-check-report.vue?vue&type=template&id=6b30d698&lang=pug&"
import script from "./registers-with-check-report.vue?vue&type=script&lang=ts&"
export * from "./registers-with-check-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports